module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/4-clean.json
// module id = 334
// module chunks = 175338278596192